<div class="ibox detailed-view-ibox" *ngIf="directoryService.showDetailedView && data">
    <div class="detailed-view-header h-fit">
        <a *ngIf="data.suiteNumber" [routerLink]="['/directory/item/' + data.suiteId + '/residents/' + data.id]">
            <span class="suite-name m-r-sm mtv-primary-color">{{data.suiteNumber}}</span>
        </a>
        <span class="building-name">{{data.buildingName || 'Create' + title}}</span>
        <span class="close-detailed-view" (click)="directoryService.toggleDetailedView(null, false)">×</span>
        <div *ngIf="isShowAccountBalance" class="account-balance">
            Account Balance: <a (click)="showAccountBalanceModal()"> {{accountBalance|currency}}</a>
        </div>
    </div>
    <div class="detailed-view-body" [ngClass]="{'no-action-button': actionButtonIsNotAvailable()}">
        <div class="detailed-view__more-info directory-detailed-view-content m-t-md">
            <form #form="ngForm" submittable autocomplete="off">
                <input type="hidden" name="id" [ngModel]="data.suiteUserId">

                <!--  ** ROLE **  -->
                <role-field
                    name="role"
                    [ngModel]="data.role"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({role: form.value.role})">
                </role-field>
                <span *ngIf="directoryService.dateIsLaterThanCurrent(data.occupancyDate)"
                      class="label resident-label">
                    Move In
                </span>
                <span *ngIf="directoryService.dateIsLaterThanCurrent(data.moveOutDate)"
                      class="label resident-label">
                    Move Out
                </span>
                <span *ngIf="directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                      title="{{data.moveOutDate | date: 'dd.MM.yyyy'}}"
                      class="label archived-item">
                    Archived
                </span>

                <div style="margin: 0 -5px; display: table;">
                    <div class="col-md-3 avatar-box" [ngClass]="{'loading': spinnerAvatar}">
                        <label class="circle-logo">
                            <input class="hidden"
                                   type="file"
                                   [disabled]="avatarUploadDisabled || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                                   (change)="changeAvatar($event)"
                                   accept="image/jpeg, image/png">
                            <img [src]="data.photo || 'assets/img/user-icon.png'"/>

                            <spinner [spinnerShow]="spinnerAvatar"></spinner>
                        </label>
                        <label *ngIf="data.photo" class="delete-avatar" (click)="removeAvatar()">
                            <i class="fa fa-trash"></i>
                        </label>
                        <label *ngIf="data.isCanEdit && !directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                               class="delete-avatar clickable camera"
                               (click)="takeImageFromWebcam($event)">
                            <i class="fa fa-camera" aria-hidden="true"></i>
                        </label>
                    </div>

                    <div class="col-md-9 profile-main-info">
                        <!--  ** FULLNAME **  -->
                        <input-field
                            name="fullName"
                            [ngModel]="data.fullName"
                            [class]="'strong full-name-field'"
                            [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                            (update)="onSubmit({fullName: form.value.fullName})">
                        </input-field>

                        <!--  ** PRIMARY PHONE **  -->
                        <div *ngIf="getPrimaryPhone(phoneField.value)">
                            <div class="row" *ngIf="getPrimaryPhone((form.dirty)?form.value.phones:data.phones)">
                                <div class="dv-value col-sm-12">
                                    <i class="fa fa-phone  m-r-sm"> </i>
                                    <span> {{ getPrimaryPhone(phoneField.value) }} </span>
                                </div>
                            </div>
                        </div>

                        <!--  ** EMAIL **  -->
                        <resident-email-field
                            name="email"
                            [icon]="'fa fa-envelope'"
                            [ngModel]="data.email"
                            [invalidEmail]="!data.isValidEmail"
                            [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                            (update)="onSubmit({email: form.value.email})"
                            [canSetAsValid]="data.isCanEdit"
                            (setAsValid)="onSubmit({isValidEmail: 1})"
                        >
                        </resident-email-field>
                    </div>
                </div>

                <hr>

                <!--  ** ALTERNATIVE EMAILS **  -->
                <resident-alternative-emails-field
                    name="alternativeEmails"
                    [ngModel]="data.alternativeEmails"
                    [value]="data.alternativeEmails"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({alternativeEmails: form.value.alternativeEmails})">
                </resident-alternative-emails-field>

                <hr>

                <div class="row m-b-xs" *ngIf="directoryService.selectedResidentInstructions.length > 0">
                    <div class="dv-label col-sm-3 strong" data-toggle="tooltip" data-placement="top">
                        Instructions
                    </div>

                    <div class="dv-value col-sm-9 mtv-primary-color clickable text-right"
                         *ngIf="!showInstructionsHistory && numberOfCurrentInstructions() < directoryService.selectedResidentInstructions.length"
                         (click)="showInstructionsHistoryTrigger(true)">
                        + Show Instructions History
                    </div>

                    <div class="dv-value col-sm-9 mtv-primary-color clickable text-right"
                         *ngIf="showInstructionsHistory || numberOfCurrentInstructions() == directoryService.selectedResidentInstructions.length"
                         (click)="showInstructionsHistoryTrigger(false)">
                        - Hide Instructions History
                    </div>
                </div>

                <div class="row m-b-xs resident-instructions-row"
                     *ngFor="let instruction of directoryService.selectedResidentInstructions; let index = index;"
                     [ngStyle]="{'display': instruction.visible ? 'block' : 'none'}">
                    <div class="col-sm-12 m-b-xs">
                        <label>{{instruction.subject}}</label>
                        <pre>{{instruction.text}}</pre>
                    </div>
                    <div class="dv-label col-sm-12">
                        <span
                            class="same-label-width label label-{{instruction.status}} m-r-sm">{{instruction.status}}</span>
                        {{instruction.startDate | date:'dd.MM.yyyy'}} <span
                        *ngIf="instruction.endDate"> - {{instruction.endDate | date:'dd.MM.yyyy'}}</span>
                        <i *ngIf="!directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                           class="fa fa-trash pull-right"
                           (click)="directoryService.deleteResidentInstruction(instruction)">
                        </i>
                        <i *ngIf="!directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                           (click)="editInstruction(instruction)"
                           class="fa fa-pencil pull-right">
                        </i>
                    </div>
                </div>

                <hr *ngIf="directoryService.selectedResidentInstructions.length > 0">

                <!--PHONES-->
                <phone-field
                    #phoneField
                    name="phones"
                    [ngModel]="data.phones"
                    [userId]="data.id"
                    (update)="onSubmit({phones: form.value.phones})"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (reset)="resetPhones($event)">
                </phone-field>
                <hr>

                <!--ADDRESS-->
                <address-field
                    [multiple]="true"
                    name="addresses"
                    [ngModel]="data.addresses"
                    [value]="data.addresses"
                    [userId]="data.id"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({addresses: form.value.addresses})">
                </address-field>

                <hr>

                <!--  ** Move In Date **  -->
                <datetime-field
                    name="occupancyDate"
                    [ngModel]="data.occupancyDate"
                    [title]="'Move In Date'"
                    [value]="data.occupancyDate"
                    [classLabel]="'dv-label col-sm-3 strong'"
                    [classValueBox]="'dv-value col-sm-9'"
                    [classValueEditBox]="'dv-value-edit col-sm-9'"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({occupancyDate: convertDate(form.value.occupancyDate)})">
                </datetime-field>

                <!--  ** Move Out Date **  -->
                <datetime-field
                    name="moveOutDate"
                    [ngModel]="data.moveOutDate"
                    [title]="'Move Out Date'"
                    [value]="data.moveOutDate"
                    [classLabel]="'dv-label col-sm-3 strong'"
                    [classValueBox]="'dv-value col-sm-9'"
                    [classValueEditBox]="'dv-value-edit col-sm-9'"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({moveOutDate: convertDate(form.value.moveOutDate)})">
                </datetime-field>

                <hr>

                <!--  ** DATE OF BIRTH **  -->
                <!--<datetime-field
                    name="dateOfBirth"
                    [ngModel]="data.dateOfBirth"
                    [title]="'DOB'"
                    [value]="data.dateOfBirth"
                    [classLabel]="'dv-label col-sm-3 strong'"
                    [classValueBox]="'dv-value col-sm-9'"
                    [classValueEditBox]="'dv-value-edit col-sm-9'"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({dateOfBirth: convertDate(form.value.dateOfBirth)})">
                </datetime-field>

                <hr>-->

                <!--GROUPS-->
                <groups-field
                    name="groups"
                    [ngModel]="data.groups"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({groups: form.value.groups})">
                </groups-field>

                <hr>

                <div class="row m-b-xs">
                    <div class="dv-label col-sm-3 strong" data-toggle="tooltip" data-placement="top">
                        Active
                    </div>

                    <div class="dv-value col-sm-9">
                        <span *ngIf="data.maxTvUser"><i class="icon-check"></i> <span class="signedLabel">Active</span></span>
                        <span *ngIf="!data.maxTvUser && data.isInvited"><i><img
                            src="../../../../../assets/img/pending.png"></i> Invited</span>
                        <span *ngIf="!data.maxTvUser && !data.isInvited"><i class="icon-close"></i> <span
                            class="signedLabel">Not Active</span></span>
                    </div>
                </div>

                <hr *ngIf="directoryService.currentCorporationSettings.useEmailWaiver ||
                           directoryService.currentCorporationSettings.useParcelsWaiver ||
                           directoryService.currentCorporationSettings.useKeyWaiver">

                <!--  ** Waiver Signed **  -->
                <boolean-field
                    *ngIf="directoryService.currentCorporationSettings.useEmailWaiver"
                    name="emailWaiverSigned"
                    [title]="'Waiver Signed'"
                    [valueTitle]="'Electronic Notifications Agreement'"
                    [ngModel]="data.emailWaiverSigned"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({emailWaiverSigned: form.value.emailWaiverSigned})">
                </boolean-field>

                <boolean-field
                    *ngIf="directoryService.currentCorporationSettings.useParcelsWaiver"
                    name="parcelWaiverSigned"
                    [title]="!directoryService.currentCorporationSettings.useEmailWaiver ? 'Waiver Signed' : ' '"
                    [valueTitle]="'Parcels'"
                    [ngModel]="data.parcelWaiverSigned"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({parcelWaiverSigned: form.value.parcelWaiverSigned})">
                </boolean-field>

                <boolean-field
                    *ngIf="directoryService.currentCorporationSettings.useKeyWaiver"
                    name="keyWaiverSigned"
                    [title]="!directoryService.currentCorporationSettings.useEmailWaiver &&
                             !directoryService.currentCorporationSettings.useParcelsWaiver ? 'Waiver Signed' : ' '"
                    [valueTitle]="'Keys'"
                    [ngModel]="data.keyWaiverSigned"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({keyWaiverSigned: form.value.keyWaiverSigned})">
                </boolean-field>

                <hr>

                <boolean-field
                    *ngIf="form.value.role == 'owner_on' || form.value.role == 'owner_off'"
                    name="ownerInformationFormReceived"
                    [title]="'Owner Info'"
                    [valueTitle]="'Owner Information Form Received'"
                    [ngModel]="data.ownerInformationFormReceived"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({ownerInformationFormReceived: form.value.ownerInformationFormReceived})">
                </boolean-field>

                <boolean-field
                    *ngIf="form.value.role == 'rent'"
                    name="leaseReceived"
                    [title]="'Tenant Info'"
                    [valueTitle]="'Lease Received'"
                    [ngModel]="data.leaseReceived"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({leaseReceived: form.value.leaseReceived})">
                </boolean-field>

                <boolean-field
                    *ngIf="form.value.role == 'rent'"
                    name="tenantInformationFormReceived"
                    [title]="' '"
                    [valueTitle]="'Information Form Received'"
                    [ngModel]="data.tenantInformationFormReceived"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({tenantInformationFormReceived: form.value.tenantInformationFormReceived})">
                </boolean-field>

                <boolean-field
                    *ngIf="form.value.role == 'rent'"
                    name="primaryLeaseHolder"
                    [title]="' '"
                    [valueTitle]="'Primary Lease Holder'"
                    [ngModel]="data.primaryLeaseHolder"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({primaryLeaseHolder: form.value.primaryLeaseHolder})">
                </boolean-field>

                <!--  ** DATE OF BIRTH **  -->
                <datetime-field
                    *ngIf="form.value.role == 'rent'"
                    name="leaseStartDate"
                    [ngModel]="data.leaseStartDate"
                    [title]="'Lease Start Date'"
                    [value]="data.leaseStartDate"
                    [classLabel]="'dv-label col-sm-4 strong'"
                    [classValueBox]="'dv-value col-sm-8'"
                    [classValueEditBox]="'dv-value-edit col-sm-8'"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({leaseStartDate: form.value.leaseStartDate})">
                </datetime-field>

                <hr *ngIf="form.value.role == 'owner_on' || form.value.role == 'owner_off' || form.value.role == 'rent'">

                <div class="row m-b-xs">
                    <div class="dv-label col-sm-3 strong" data-toggle="tooltip" data-placement="top">
                        Consent
                    </div>

                    <div class="dv-value col-sm-3">
                        <i *ngIf="data.consent && data.consent.isSigned == 1" class="icon-check"></i>
                        <i *ngIf="!data.consent || data.consent.isSigned == 0" class="icon-close"></i>
                    </div>

                    <div class="dv-value col-sm-6" *ngIf="!directoryService.dateIsEarlierThanCurrent(data.moveOutDate)">
                        <i *ngIf="data.consent && data.consent.isSigned == 1 && data.consent.pathToPdf"
                           class="fa fa-file-pdf-o  mtv-primary-color"
                           aria-hidden="true"
                           style="cursor: pointer; font-size: 18px;"
                           (click)="directoryService.openPdfInNewTab(data.consent.pathToPdf)"></i>
                        <i *ngIf="!data.consent || data.consent.isSigned == 0"
                           class="icon-plus pull-right"
                           (click)="clickConsentInput()"></i>
                        <i *ngIf="data.consent && data.consent.isSigned == 1"
                           (click)="uploadConsent(data.id, null, false)"
                           class="fa fa-trash pull-right"></i>
                        <input id="fileInput" name="fileInput" type="file" class="hidden"
                               (change)="onFileInput($event)">
                    </div>
                </div>

                <hr>

                <!--  ** EMERGENCY CONTACT **  -->
                <emergency-contacts-field [ngModel]="data.emergencyContacts"
                                          name="emergencyContacts"
                                          [title]="'Emerg. Cont.'"
                                          [objectId]="data.suiteId"
                                          [propertyName]="'suite'"
                                          (update)="onSubmit({emergencyContacts: form.value.emergencyContacts})"
                                          [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)">
                </emergency-contacts-field>

                <!--  ** EMERGENCY ASSISTANT NOTES **  -->
                <input-field
                    name="emergencyAssistantNotes"
                    [ngModel]="data.emergencyAssistantNotes"
                    [title]="'Emerg. Notes'"
                    [tooltipText]="'Emergency Assistant Notes'"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({emergencyAssistantNotes: form.value.emergencyAssistantNotes})">
                </input-field>

                <!--  ** DISABILITIES **  -->
                <textarea-field
                    name="disabilities"
                    [ngModel]="data.disabilities"
                    [maxLength]="255"
                    [title]="'Disabilities'"
                    [tooltipText]="'Disabilities'"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({disabilities: form.value.disabilities})">
                </textarea-field>

                <!--** note ** -->
                <textarea-field
                    [ngModel]="data.note"
                    [maxLength]="255"
                    name="note"
                    [tooltipText]="'Note'"
                    [title]="'Note'"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({note: form.value.note})">
                </textarea-field>

                <hr>

                <!--** Buzz ** -->
                <directory-unit-array-input-field
                    [ngModel]="data.buzzFields"
                    name="buzz"
                    [tooltipText]="'Buzz'"
                    [title]="'Buzz'"
                    [userId]="data.id"
                    [suiteUsers]="[{user:{id: data.id, fullName: data.fullName}}]"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="arrayFieldsSubmit('buzzFields', {buzzFields: form.value.buzz})">
                </directory-unit-array-input-field>

                <!--** Key Code ** -->
                <directory-unit-array-input-field
                    [ngModel]="data.keyCodeFields"
                    name="keyCode"
                    [tooltipText]="'Key Code'"
                    [title]="'Key Code'"
                    [userId]="data.id"
                    [suiteUsers]="[{user: {id: data.id, fullName: data.fullName}}]"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="arrayFieldsSubmit('keyCodeFields', {keyCodeFields: form.value.keyCode})">
                </directory-unit-array-input-field>

                <!--** Key Fob ** -->
                <directory-unit-array-input-field
                    [ngModel]="data.keyFobFields"
                    name="keyFob"
                    [tooltipText]="'Key Fob'"
                    [title]="'Key Fob'"
                    [userId]="data.id"
                    [suiteUsers]="[{user:{id: data.id, fullName: data.fullName}}]"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="arrayFieldsSubmit('keyFobFields', {keyFobFields: form.value.keyFob})">
                </directory-unit-array-input-field>

                <hr>

                <div class="row">
                    <div class="col-md-3 dv-label">
                        <label>Vehicles</label>
                    </div>
                    <div class="col-md-9 dv-value">
                        <div *ngIf="data.vehicles.length < 1">-</div>
                        <div *ngFor="let vehicle of data.vehicles; let last = last;">
                            {{vehicle.color}} {{vehicle.brand}} {{vehicle.model}} {{vehicle.year}} {{vehicle.licensePlate}}
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3 dv-label">
                        <label>Pets</label>
                    </div>
                    <div class="col-md-9 dv-value">
                        <div *ngIf="data.pets.length < 1">-</div>
                        <div *ngFor="let pet of data.pets; let last = last;">
                            {{pet.petType ? pet.petType.name : ''}} {{pet.name}}
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <hr *ngIf="data.id &&
                   (data.isCanEdit || data.isCanDelete || data.maxTvUser ||
                    (!directoryService.dateIsEarlierThanCurrent(data.moveOutDate) && (directoryService.account.canUpdate('amenity') || directoryService.account.canUpdate('parking_pass'))))">

        <div class="btn-group dropup directory-actions"
             *ngIf="data.id &&
                            (data.isCanEdit || data.isCanDelete || data.maxTvUser ||
                             (!directoryService.dateIsEarlierThanCurrent(data.moveOutDate) && (directoryService.account.canUpdate('amenity') || directoryService.account.canUpdate('parking_pass'))))">
            <a data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle">
                Actions <span class="caret"></span>
            </a>
            <ul class="dropdown-menu multi-level">
                <li class="dropdown-submenu"
                    *ngIf="data.isCanEdit &&
                           (data.email || (directoryService.getCellPhones(data.phones).length > 0 && directoryService.showSendSms())) &&
                           !directoryService.dateIsEarlierThanCurrent(data.moveOutDate)">
                    <a>Send</a>
                    <ul class="dropdown-menu">
                        <li *ngIf="data.email">
                            <a (click)="sendInvitation(false)">Send Message</a>
                        </li>
                        <li *ngIf="data.isCanEdit && directoryService.getCellPhones(data.phones).length > 0 &&
                                   directoryService.showSendSms()">
                            <a (click)="directoryService.sendSms(data)">Send SMS</a>
                        </li>
                        <li *ngIf="data.email && !data.maxTvUser">
                            <a (click)="sendInvitation(true)">
                                <span *ngIf="data.maxTvUser">Resend</span><span *ngIf="!data.maxTvUser">Send</span>
                                Invitation
                            </a>
                        </li>
                        <li *ngIf="data.email">
                            <a (click)="sendTestMessage()">
                                Send Test Message
                            </a>
                        </li>
                    </ul>
                </li>
                <li *ngIf="data && !directoryService.dateIsEarlierThanCurrent(data.moveOutDate)
                                   && (directoryService.account.canUpdate('amenity') || directoryService.account.canUpdate('parking_pass'))"
                    class="dropdown-submenu">
                    <a tabindex="-1">Add</a>
                    <ul class="dropdown-menu">
                        <li *ngIf="directoryService.account.canUpdate('amenity')">
                            <a (click)="directoryService.bookAmenityForResident(data)">Add Amenity Booking</a>
                        </li>
                        <li *ngIf="directoryService.account.canUpdate('parking_pass')">
                            <a (click)="directoryService.createParkingPassForResident(data)">Add Parking Pass</a>
                        </li>
                    </ul>
                </li>
                <li class="dropdown-submenu"
                    *ngIf="data && !directoryService.dateIsEarlierThanCurrent(data.moveOutDate)">
                    <a tabindex="-1">Instructions</a>
                    <ul class="dropdown-menu">
                        <li><a (click)="addInstructions('entry')">Entry Instructions</a></li>
                        <li><a (click)="addInstructions('vacation')">Vacation Notice</a></li>
                    </ul>
                </li>
                <li *ngIf="data.maxTvUser && !directoryService.dateIsEarlierThanCurrent(data.moveOutDate)">
                    <a (click)="resetPassword(data)">Reset Password</a>
                </li>
                <li *ngIf="data.isCanDelete &&
                                   (!data.moveOutDate || directoryService.dateIsLaterThanCurrent(data.moveOutDate)) &&
                                   !directoryService.dateIsEarlierThanCurrent(data.moveOutDate)">
                    <a (click)="moveResidentOut(data)">Move Out</a>
                </li>
                <li (click)="patch(form.value.id, {moveOutDate: null})"
                    *ngIf="data.isCanEdit && directoryService.dateIsEarlierThanCurrent(data.moveOutDate)">
                    <a>Restore</a>
                </li>
                <li (click)="remove(form.value.id)"
                    *ngIf="data.isCanDelete && directoryService.dateIsEarlierThanCurrent(data.moveOutDate)">
                    <a>Delete</a>
                </li>
            </ul>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/detailed-view/resident-view/resident-view.component.html